var map = {
	"./ar.svg": 1822,
	"./de.svg": 7254,
	"./el.svg": 3324,
	"./en.svg": 4414,
	"./es.svg": 2971,
	"./fr.svg": 4563,
	"./it.svg": 8824,
	"./lt.svg": 9423,
	"./lv.svg": 8941,
	"./pl.svg": 1995,
	"./ru.svg": 3160,
	"./uk.svg": 8723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1723;